// Game status enum - uses string values matching backend status_str
// This enum is used throughout the app to track game progression
export enum GameStatus {
  GameStatusIgnore = 'ignore',
  GameStatusInvalid = 'invalid',

  GameStatusLobby = 'lobby',
  GameStatusPostLobby = 'post_lobby',

  GameStatusPreQuickStart = 'pre_quick_start',
  GameStatusQuickStart = 'quick_start',
  GameStatusPostQuickStart = 'post_quick_start',

  GameStatusMinors = 'minors',
  GameStatusPostMinors = 'post_minors',

  GameStatusPreCharacters = 'pre_characters',
  GameStatusCharacters = 'characters',
  GameStatusPostCharacters = 'post_characters',

  GameStatusPreStoryCreate = 'pre_story_create',
  GameStatusStoryCreate = 'story_create',
  GameStatusPostStoryCreate = 'post_story_create',

  GameStatusPreStoryWrite = 'pre_story_write',
  GameStatusStoryWriteTransition = 'story_write_transition',
  GameStatusStoryWrite = 'story_write',
  GameStatusPostStoryWrite = 'post_story_write',

  GameStatusPreStoryTitle = 'pre_story_title',
  GameStatusStoryTitle = 'story_title',
  GameStatusPostStoryTitle = 'post_story_title',

  GameStatusPreCensoring = 'pre_censoring',
  GameStatusCensoring = 'censoring',
  GameStatusPostCensoring = 'post_censoring',

  GameStatusPreVoting = 'pre_reading',
  GameStatusReacting = 'reacting',
  GameStatusVoting = 'voting',
  GameStatusPostReading = 'post_reading',

  GameStatusPreResults = 'pre_results',
  GameStatusResults = 'results',
}
